import React, {
    createContext,
    useContext,
    useEffect,
    useState,
   
  } from "react";
  import ReactDOM from "react-dom";
//   import { CircleCrossCloseIcon } from "../Icons";
  
  const ModalContext = createContext();
  
  export const ModalProvider = ({ children }) => {
    const [modalContent, setModalContent] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
  
    const [header, setHeader] = useState(true);
    const [modalSize, setModalSize] = useState("w-1/2"); // Default size
    const [title, setTitle] = useState(null);
    const [mode, setMode] = useState("modal"); // Default mode is 'modal'
  
    useEffect(() => {
      if (isModalOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
      // Cleanup to restore scroll on unmount
      return () => {
        document.body.style.overflow = "auto";
      };
    }, [isModalOpen]);
  
   
  
    const openModal = (title, content, options = {}) => {
      const { size = "w-1/2", mode = "modal", header = true } = options; // Destructure size and mode
      setTitle(title);
      setModalSize(size);
      setModalContent(content);
      setHeader(header);
      setMode(mode);
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setModalContent(null);
      setIsModalOpen(false);
      setMode("modal"); // Reset to default mode
    };
  
    // const handleClickOutside = (e) => {
    //   if (e.target.classList.contains("overlayClose")) {
    //     closeModal();
    //   }
    // };
  
    return (
      <ModalContext.Provider value={{ openModal, closeModal }}>
        {children}
        {isModalOpen &&
          ReactDOM.createPortal(
            <div
              className={`fixed inset-0 z-40 ${
                mode === "sidebar"
                  ? "flex items-start"
                  : "flex items-center justify-center"
              } bg-black bg-opacity-50 overlayClose`}
            //   onClick={handleClickOutside}
            >
              <div
                className={`bg-white shadow-lg relative mx-1 sm:ml-3 ${
                  mode === "sidebar"
                    ? "w-full max-w-full md:max-w-[503px] h-screen overflow-y-hidden ml-auto "
                    : `rounded-lg ${modalSize}`
                }`}
              >
                {header && (
                  <>
                    <div
                      className={`flex relative justify-between p-5 ${
                        mode === "sidebar" ? "" : "rounded-t-lg border-b"
                      }`}
                    >
                      {/* Title */}
                      <h2 className="text-lg font-semibold">{title}</h2>
                      {/* Close Button */}
                      <button
                        onClick={closeModal}
                        className="opacity-60 hover:opacity-100 focus:outline-none cursor-pointer"
                      >
                        {/* <CircleCrossCloseIcon /> */} X
                      </button>
                    </div>
  
                    {/* <div className={`overflow-y-auto p-5 ${mode == 'sidebar' ? `min-h-[85vh]` : `max-h-[75vh]` }`}>{modalContent}</div> */}
  
                    <div>
                      {mode === "sidebar" ? (
                        <div className="flex-grow p-5 pb-16 overflow-y-auto h-[85vh]">
                        <div className="h-full min-h-fit">
                          {modalContent}
                        </div>
                      </div>
                      ) : (
                        <div className="overflow-y-auto p-5 max-h-[75vh]">
                          {modalContent}
                        </div>
                      )}
                    </div>
                  </>
                )}
  
                {!header && <div>{modalContent}</div>}
              </div>
            </div>,
            document.body
          )}
      </ModalContext.Provider>
    );
  };
  
  export const useModal = () => useContext(ModalContext);
  
  // Example Usage:
  
  // Import the useModal hook and ModalProvider component
  // import { useModal, ModalProvider } from './utils/Modal';
  
  // Wrap your application with the ModalProvider
  // function App() {
  //   return (
  //     <ModalProvider>
  //       <YourComponents />
  //     </ModalProvider>
  //   );
  // }
  
  // Use the useModal hook in any component to control the modal
  // function ExampleComponent() {
  //   const { openModal, closeModal } = useModal();
  
  //   const handleOpenModal = () => {
  //     openModal("My Modal Title", <p>This is the modal content</p>, { size: "w-1/3", mode: "modal" });
  //   };
  
  //   return (
  //     <div>
  //       <button onClick={handleOpenModal}>Open Modal</button>
  //     </div>
  //   );
  // }
  
